import { notifications } from "@mantine/notifications";
import { generateRewardLink } from "@/utils/api/referrals";
import { openNewTab } from "@/utils/browserUtils";

/**
 * Handle reward link click - generates link via API and opens in new tab
 */
export const handleViewReward = async (
  _rewardId: string,
  rewardDbId: string
) => {
  try {
    const result = await generateRewardLink(rewardDbId);
    // Open the link in a new tab
    openNewTab(result.link);
  } catch (error) {
    console.error("Error generating reward link:", error);
    notifications.show({
      title: "Error",
      message: "Failed to generate reward link. Please try again.",
      color: "red",
    });
  }
};
